import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#79dfb6', light: '#a6f0d1', dark: '#3fae84', contrastText: '#07120f' },
    secondary: { main: '#ffb86b', contrastText: '#201005' },
    background: { default: '#07111b', paper: '#0e1c29' },
    success: { main: '#72df98' },
    warning: { main: '#ffbd66' },
    error: { main: '#ff7381' },
    text: { primary: '#f4f8fb', secondary: '#a9bac8' },
    divider: 'rgba(177, 205, 224, 0.14)',
  },
  typography: {
    fontFamily: 'Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    h1: { fontWeight: 760, letterSpacing: '-0.045em' },
    h2: { fontWeight: 740, letterSpacing: '-0.035em' },
    h3: { fontWeight: 700, letterSpacing: '-0.025em' },
    button: { fontWeight: 700, textTransform: 'none' },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: { background: '#07111b' },
        body: {
          margin: 0,
          minWidth: 320,
          background:
            'radial-gradient(circle at 12% -10%, rgba(64, 172, 139, .2), transparent 35rem), #07111b',
        },
        audio: { width: '100%', height: 42, colorScheme: 'dark' },
        '::selection': { background: '#79dfb6', color: '#07120f' },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'linear-gradient(145deg, rgba(255,255,255,.025), rgba(255,255,255,0))',
          border: '1px solid rgba(177, 205, 224, 0.11)',
        },
      },
    },
    MuiButton: { defaultProps: { disableElevation: true } },
    MuiTextField: { defaultProps: { size: 'small' } },
  },
});
